import React from 'react';

// Every reference to a month on Sales surfaces carries one of:
//   CLOSED   — Bianca signed off; numbers are the book of record.
//   REVISED  — closed, then changed by a late refund or PP conversion; shows delta.
//   TENTATIVE — month is not yet closed; must never be silently compared to closed months.
//   MATURING — cohort month + 14 days: cohort-clock numbers still shifting.
export function MonthStatusBadge({ status, delta, testId }) {
  const cfg = {
    closed:    { label: 'Closed',    cls: 'bg-emerald-600 text-white' },
    revised:   { label: 'Revised',   cls: 'bg-amber-500 text-indie-ink' },
    tentative: { label: 'Tentative', cls: 'bg-rose-600 text-white' },
    maturing:  { label: 'Maturing',  cls: 'bg-indie-cobalt text-white' },
  }[status];
  if (!cfg) return null;

  return (
    <span
      data-testid={testId || `month-status-${status}`}
      className={`inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.16em] font-semibold px-1.5 py-0.5 ${cfg.cls}`}
      title={{
        closed: 'Month has been signed off. Numbers are the book of record.',
        revised: 'A closed month\'s actuals changed after close (usually a refund or payment-plan conversion). Delta shown.',
        tentative: 'This month is not yet closed. Do not compare it directly to closed months.',
        maturing: 'Cohort month is within the 14-day maturity window; cohort-clock metrics may still shift.',
      }[status]}
    >
      {cfg.label}
      {status === 'revised' && delta != null && (
        <span className="font-normal">
          {delta > 0 ? '+' : ''}{delta}
        </span>
      )}
    </span>
  );
}
